namespace Solovis.Site.AlertManager {

    // Internally, we will save the N most recent alerts for diagnostic purposes.
    export var _recentAlerts = [];

    // List of active AlertInstances.
    export var _activeAlerts = [];

    // Handle for canceling the interval timer when not needed.
    export var _timerHandle = null;

    export var _spaceBetweenAlerts = 20;
    export var _defaultAlertLifeSpan = 1750;

    export var _needToUpdatePanelOffsets;


    export interface AlertOptions {
        allowCollapse?: boolean;
        code?: string;
        text?: string;
    };

    /*
     * options:
     *  text: message for the alert
     *  allowCollapse: indicates if alert can be combined with previous alert panel
     *  code: if allowCollapse is true, this indicates the alert panel that it can be combined with
     */
    export function alert(options: AlertOptions) {
        AlertManager._saveToRecentAlerts(options);

        var collapsed = false;
        if (options.allowCollapse) {
            // We should see if we can collapse this alert onto an existing one.
            for (var i = 0; i < AlertManager._activeAlerts.length; i++) {
                var instance = AlertManager._activeAlerts[i];

                if (options.code && instance.options.code == options.code) {
                    // We can collapse the notifcations into one. This should extend the alert's life.
                    instance.handleCollapse(options);
                    collapsed = true;
                }
            }
        }

        if (!collapsed) {
            var alertInstance = new Solovis.Site.AlertInstance(options);
            AlertManager._activeAlerts.push(alertInstance);
            alertInstance.show();
        }

        AlertManager._startTimer();
    };

    export function _saveToRecentAlerts(alertOptions) {
        var maxAlertsToRemember = 10;

        AlertManager._recentAlerts.push(alertOptions);
        if (AlertManager._recentAlerts.length > maxAlertsToRemember) {
            AlertManager._recentAlerts = AlertManager._recentAlerts.slice(AlertManager._recentAlerts.length - maxAlertsToRemember);
        }
    };

    export function _startTimer() {
        if (!AlertManager._timerHandle) {
            AlertManager._timerHandle = setInterval(function () { AlertManager._onTick(); }, 100);
        }
    };

    export function _onTick() {
        // See if there are any active alerts we should remove.
        var alertsToRemove = [];
        $(AlertManager._activeAlerts).each(function (i, alertInstance: any) {
            if (alertInstance.shouldRemove()) {
                alertsToRemove.push(alertInstance);
            }
        });

        $(alertsToRemove).each(function (i, alertInstance: any) {
            AlertManager._removeAlert(alertInstance);
        });

        // See if there are any alerts to reposition.
        if (AlertManager._needToUpdatePanelOffsets) {
            AlertManager._updateTopOffsetForAlerts();
            AlertManager._needToUpdatePanelOffsets = false;
        }

        // See if we still need the timer.
        if (AlertManager._activeAlerts.length == 0) {
            if (AlertManager._timerHandle !== null) {
                clearInterval(AlertManager._timerHandle);
                AlertManager._timerHandle = null;
            }
        }
    }

    export function _updateTopOffsetForAlerts() {
        var topOffset = 100;
        for (var i = 0; i < AlertManager._activeAlerts.length; i++) {
            var instance = AlertManager._activeAlerts[i];

            if (instance.container) {
                var offset = instance.container.offset();
                if (offset.top != topOffset) {
                    // Animate the motion into new position.
                    instance.container.animate({ top: topOffset }, 500);
                }

                topOffset += instance.container ? instance.container.outerHeight() : 0;
                topOffset += AlertManager._spaceBetweenAlerts;
            }
        }

        return topOffset;
    }

    export function _removeAlert(alertInstance) {
        alertInstance.destroy();
        AlertManager._activeAlerts = _.filter(AlertManager._activeAlerts, function (entry) { return entry !== alertInstance; });
        AlertManager._needToUpdatePanelOffsets = true;
    }
}
   

namespace Solovis.Site {

    export class AlertInstance {

        public options: Solovis.Site.AlertManager.AlertOptions;
        public lifeSpan;
        public showTime;
        public content;

        public container;

        public _destroyed: boolean;

        private _closeLink;

        constructor(options: Solovis.Site.AlertManager.AlertOptions) {
            this.options = options;

            this.lifeSpan = Solovis.Site.AlertManager._defaultAlertLifeSpan;
        }

        public show() {
            var self = this;

            this.showTime = new Date();

            var zIndex = Solovis.UI.DomHelper.findMaxZIndexForElementChildren(document.body);

            this.container = $("<div>")
                .addClass("site-alert-panel")
                .css("z-index", zIndex)
                .css("width", "200px")
                .css("height", "50px")
                .css("right", "" + Solovis.Site.AlertManager._spaceBetweenAlerts + "px")
                .css("top", "0px")
                .css("display", "none")
                .appendTo(document.body);

            this.content = $("<div>")
                .addClass("site-alert-panel-content")
                .text(this.options.text)
                .appendTo(this.container);

            this._closeLink = $("<a>").html("<span class='fa fa-times'></span>")
                .css("color", "#fff")
                .css("display", "block")
                .css("position", "absolute")
                .css("top", "0")
                .css("right", "3px")
                .appendTo(this.container);
            this._closeLink.click(function () {
                self.destroy();
            });

            var top = Solovis.Site.AlertManager._updateTopOffsetForAlerts();

            this.container.fadeIn();
        }

        public shouldRemove() {
            var time = new Date();
            var elapsedMilliseconds = (time as any) - this.showTime;
            if (elapsedMilliseconds > this.lifeSpan) {
                return true;
            }

            return false;
        }

        public handleCollapse(options) {
            // NOTE: We could update a badge with a count of the number of alerts.
            // We update showTime to extend notifications life.
            this.showTime = new Date();

            // Update the content.
            this.content.text(options.text);
        }

        public destroy() {
            var self = this;

            if (!this._destroyed) {
                this._destroyed = true;

                this.container.fadeOut(function () {
                    self.container.remove();
                    Solovis.Site.AlertManager._removeAlert(self);
                });
            }
        }
    }

}
 